import type { AdminDebugSubscription200DataMetadata } from './adminDebugSubscription200DataMetadata';

export type AdminDebugSubscription200Data = {
  billingKey?: string;
  errors?: string[];
  metadata?: AdminDebugSubscription200DataMetadata;
  orderId?: string;
  status?: string;
  userId?: string;
};
